import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { StaffMealsService } from '../../../../core/services/staff-meals.service';
import { Booking } from '../../../../app';

@Component({
  selector: 'app-rate-meal-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './rate-meal-modal.html',
  styleUrl: './rate-meal-modal.scss'
})
export class RateMealModalComponent implements OnInit {
  @Input() booking!: Booking;
  @Input() isReadOnly: boolean = false;
  @Output() closed = new EventEmitter<void>();
  @Output() rated = new EventEmitter<{ bookingId: string; rating: number; comment?: string }>();

  rating: number = 0;
  hoveredStar: number = 0;
  comment: string = '';
  isSubmitting: boolean = false;
  isAlreadyRated: boolean = false;
  errorMessage: string = '';
  maxCommentLength: number = 500;

  constructor(
    private staffMealsService: StaffMealsService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    if (this.booking?.hasMealRating || this.isReadOnly) {
      this.fetchExistingRating();
    }
  }

  fetchExistingRating(): void {
    if (!this.booking?.id) return;
    this.isSubmitting = true;
    this.staffMealsService.getMealRating(this.booking.id).subscribe({
      next: (res: any) => {
        this.isSubmitting = false;
        const data = res.data || res;
        if (data) {
          this.rating = data.rating || 0;
          this.comment = data.comment || '';
          this.isAlreadyRated = true;
        }
        this.cdr.detectChanges();
      },
      error: (err: any) => {
        this.isSubmitting = false;
        console.error('Failed to load meal rating:', err);
        this.cdr.detectChanges();
      }
    });
  }

  setRating(star: number): void {
    if (this.isAlreadyRated || this.isReadOnly) return;
    this.rating = star;
  }

  setHoveredStar(star: number): void {
    if (this.isAlreadyRated || this.isReadOnly) return;
    this.hoveredStar = star;
  }

  clearHoveredStar(): void {
    this.hoveredStar = 0;
  }

  submitRating(): void {
    if (this.rating < 1 || this.rating > 5 || this.isSubmitting || this.isAlreadyRated) return;

    this.isSubmitting = true;
    this.errorMessage = '';

    const payload = {
      rating: this.rating,
      comment: this.comment.trim() ? this.comment.trim() : undefined
    };

    this.staffMealsService.rateMeal(this.booking.id, payload).subscribe({
      next: (res: any) => {
        this.isSubmitting = false;
        this.rated.emit({
          bookingId: this.booking.id,
          rating: this.rating,
          comment: this.comment
        });
        this.cdr.detectChanges();
        this.closed.emit();
      },
      error: (err: any) => {
        this.isSubmitting = false;
        if (err.status === 409) {
          this.isAlreadyRated = true;
          const existingData = err.error?.data;
          if (existingData) {
            this.rating = existingData.rating || this.rating;
            this.comment = existingData.comment || this.comment;
          }
          this.errorMessage = 'You have already submitted a rating for this meal.';
        } else {
          this.errorMessage = err.error?.message || 'Failed to submit rating. Please try again.';
        }
        this.cdr.detectChanges();
      }
    });
  }

  closeModal(): void {
    this.closed.emit();
  }
}
